'use client'

import React from 'react'
import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter
} from "reactstrap"
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditor from "components/MyEditor";

export const ESG4PlusCard3 = ({ validation, pageView }) => {
    return (
            <Card style={{ backgroundColor: "#fbffd3ff" }}>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                <i className='bx bx-cube-alt'></i> Inclusive Society
            </h5>
            <CardBody>
                <Row>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab3Title"
                            className="col-md-12 col-form-label"
                        >
                            Title
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab3Title"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab3Title"

                                onChange={(e) => {
                                    validation.setFieldValue("tab3Title", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Title}
                                invalid={validation.touched.tab3Title && validation.errors.tab3Title ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab3Title && validation.errors.tab3Title && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Title}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_icon1)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_icon1"
                                label="Icon1"
                                required={true}
                                description="description"
                                widthSize={48}
                                heightSize={48}
                                value={validation.values.tab3_icon1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_icon1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_icon1', {})
                                }}
                            />
                            {validation.touched.tab3_icon1 && validation.errors.tab3_icon1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_icon1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_icon2)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_icon2"
                                label="Icon2"
                                required={true}
                                description="description"
                                widthSize={80}
                                heightSize={80}
                                value={validation.values.tab3_icon2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_icon2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_icon2', {})
                                }}
                            />
                            {validation.touched.tab3_icon2 && validation.errors.tab3_icon2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_icon2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab3Detail"
                            className="col-md-12 col-form-label"
                        >
                            Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab3Detail"
                                placeholder=""
                                name="tab3Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab3Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Detail}
                                invalid={
                                    validation.touched.tab3Detail &&
                                        validation.errors.tab3Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab3Detail &&
                                validation.errors.tab3Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_bg)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_bg"
                                label="Background"
                                required={true}
                                description="description"
                                widthSize={2160}
                                heightSize={618}
                                value={validation.values.tab3_bg}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_bg', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_bg', {})
                                }}
                            />
                            {validation.touched.tab3_bg && validation.errors.tab3_bg && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_bg}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab3Detail2"
                            className="col-md-12 col-form-label"
                        >
                            Detail2
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab3Detail2"
                                placeholder=""
                                name="tab3Detail2"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab3Detail2",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Detail2}
                                invalid={
                                    validation.touched.tab3Detail2 &&
                                        validation.errors.tab3Detail2
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab3Detail2 &&
                                validation.errors.tab3Detail2 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Detail2}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab3Detail3"
                            className="col-md-12 col-form-label"
                        >
                            Detail3
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab3Detail3"
                                placeholder=""
                                name="tab3Detail3"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab3Detail3",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Detail3}
                                invalid={
                                    validation.touched.tab3Detail3 &&
                                        validation.errors.tab3Detail3
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab3Detail3 &&
                                validation.errors.tab3Detail3 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Detail3}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab3Detail4"
                            className="col-md-12 col-form-label"
                        >
                            Detail4
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab3Detail4"
                                placeholder=""
                                name="tab3Detail4"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab3Detail4",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Detail4}
                                invalid={
                                    validation.touched.tab3Detail4 &&
                                        validation.errors.tab3Detail4
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab3Detail4 &&
                                validation.errors.tab3Detail4 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Detail4}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    
                    <Col className="col-6 mb-3">
                        <label
                            htmlFor="tab3Detail5"
                            className="col-md-12 col-form-label"
                        >
                            Detail5
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab3Detail5"
                                placeholder=""
                                name="tab3Detail5"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab3Detail5",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab3Detail5}
                                invalid={
                                    validation.touched.tab3Detail5 &&
                                        validation.errors.tab3Detail5
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab3Detail5 &&
                                validation.errors.tab3Detail5 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab3Detail5}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>

                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_card_image1)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_card_image1"
                                label="Image1"
                                required={true}
                                description="description"
                                widthSize={976}
                                heightSize={640}
                                value={validation.values.tab3_card_image1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image1', {})
                                }}
                            />
                            {validation.touched.tab3_card_image1 && validation.errors.tab3_card_image1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_card_image1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_card_image2)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_card_image2"
                                label="Image2"
                                required={true}
                                description="description"
                                widthSize={976}
                                heightSize={640}
                                value={validation.values.tab3_card_image2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image2', {})
                                }}
                            />
                            {validation.touched.tab3_card_image2 && validation.errors.tab3_card_image2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_card_image2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_card_image3)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_card_image3"
                                label="Image3"
                                required={true}
                                description="description"
                                widthSize={976}
                                heightSize={640}
                                value={validation.values.tab3_card_image3}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image3', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image3', {})
                                }}
                            />
                            {validation.touched.tab3_card_image3 && validation.errors.tab3_card_image3 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_card_image3}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab3_card_image4)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab3_card_image4"
                                label="Image4"
                                required={true}
                                description="description"
                                widthSize={976}
                                heightSize={640}
                                value={validation.values.tab3_card_image4}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image4', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab3_card_image4', {})
                                }}
                            />
                            {validation.touched.tab3_card_image4 && validation.errors.tab3_card_image4 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab3_card_image4}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>

                    <Col className="col-12 mb-3">
                                            <label
                                                htmlFor="tab3LinkUrl"
                                                className="col-md-12 col-form-label"
                                            >
                                                Link URL
                                                {/* <span className="t-require">*</span> */}
                                            </label>
                                            <div className="col-md-12">
                                                <Input
                                                    id="tab3LinkUrl"
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    name="tab3LinkUrl"
                    
                                                    onChange={(e) => {
                                                        validation.setFieldValue("tab3LinkUrl", e.target.value)
                                                    }}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.tab3LinkUrl}
                                                    invalid={validation.touched.tab3LinkUrl && validation.errors.tab3LinkUrl ? true : false}
                                                    disabled={pageView === "view"}
                                                />
                                                {
                                                    validation.touched.tab3LinkUrl && validation.errors.tab3LinkUrl && (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.tab3LinkUrl}
                                                        </FormFeedback>
                                                    )
                                                }
                                            </div>
                                            <hr />
                                        </Col>
                </Row>
            </CardBody>
        </Card>

    )
}